import { removeItem, replaceItem } from "../../../common/state/common";
import { IFeature, ILoadableWrapper, onLoadableLoad, onLoadableSuccess, toLoadableWrapper } from "../../../common/models";

export function addFeature(currentFeatures: ILoadableWrapper<IFeature>[], newFeature: IFeature): ILoadableWrapper<IFeature>[] {
    if (newFeature == undefined || newFeature.id == undefined) {
        return currentFeatures;
    }

    return currentFeatures.concat(toLoadableWrapper(newFeature));
}

export function replaceFeature(currentFeatures: ILoadableWrapper<IFeature>[], updatedFeature: IFeature): ILoadableWrapper<IFeature>[] {
    if (updatedFeature == undefined || updatedFeature.id == undefined) {
        return currentFeatures;
    }

    return replaceItem(currentFeatures, onLoadableSuccess(toLoadableWrapper(updatedFeature)));
}

export function setFeatureLoading(currentFeatures: ILoadableWrapper<IFeature>[], feature: IFeature): ILoadableWrapper<IFeature>[] {
    if (feature == undefined || feature.id == undefined) {
        return currentFeatures;
    }

    return replaceItem(currentFeatures, onLoadableLoad(toLoadableWrapper(feature)));
}

export function removeFeature(currentFeatures: ILoadableWrapper<IFeature>[], removedFeature: IFeature): ILoadableWrapper<IFeature>[] {
    if (removedFeature == undefined || removedFeature.id == undefined) {
        return currentFeatures;
    }

    return removeItem(currentFeatures, removedFeature.id);
}

export function clearFeatures(): ILoadableWrapper<IFeature>[] {
    return [];
}